import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-column-fluid h-300px overlay overlay-block rounded" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-column-fluid overlay-layer rounded bg-dark bg-opacity-5" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-flex spinner-border text-primary",
      role: "status"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _ctx.$route.path
          }))
        ]),
        fallback: _withCtx(() => [
          _hoisted_1
        ]),
        _: 2
      }, 1024))
    ]),
    _: 1
  }))
}